import { Component, Input } from '@angular/core';
import { IPhysicianNew } from '@core/model';
import { PhysicianAccountPgpDTO } from '@mynexus/mynexus-ui-lib';

@Component({
    selector: 'app-physician-provider',
    templateUrl: './physician-provider.component.html',
    styleUrls: ['./physician-provider.component.scss'],
    standalone: false
})
export class PhysicianProviderComponent {
  physicianTableData: IPhysicianNew = {};

  private isExternal = false;
  private physicianData: PhysicianAccountPgpDTO;
  private physicianNewData: IPhysicianNew;

  @Input() set isExternalUser(value: boolean) {
    this.isExternal = value;
  }

  get isExternalUser(): boolean {
    return this.isExternal;
  }

  @Input() set physicianNew(value: IPhysicianNew) {
    if (value) {
      this.physicianNewData = value;
      this.physicianTableData = value;
    }
  }

  get physicianNew(): IPhysicianNew {
    return this.physicianNewData;
  }

  @Input() set physician(value: PhysicianAccountPgpDTO) {
    if (value) {
      const { physicianAccountDTO, physicianPgpDTO } = value;

      this.physicianData = value;
      this.physicianTableData = { ...physicianAccountDTO, ...physicianPgpDTO };
    }
  }

  get physician(): PhysicianAccountPgpDTO {
    return this.physicianData;
  }

  @Input() physicianType: string;


}
